export const ru = {
    administration: 'Администрирование',
    'advanced-forecast-description':
        'Расчет примерных расходов для разных регионов показа и ключевых фраз, и ориентировочная стоимость перехода по объявлениям.',
    'budget-forecast': 'Прогноз бюджета',
    'campaigns-of-client': 'Кампании клиента',
    create: 'Создать кампанию',
    'deals-list': 'Список сделок {count}',
    'internal-ads-search': 'Поиск внутренней рекламы',
    library: 'Библиотека',
    marketers: 'Маркетологи',
    'my-campaigns': 'Мои кампании',
    'my-clients': 'Мои клиенты',
    products: 'Продукты',
    recommendations: 'Рекомендации',
    'recommendations-tooltip-content':
        'Директ пересчитывает рекомендации для ваших кампаний несколько раз в день. Посмотрите, что рассчитано в этот раз.',
    'recommendations-tooltip-header': 'Рекомендации по улучшению кампаний',
    search: 'Поиск',
    tools: 'Инструменты',
    'turbo-landing-constructor': 'Конструктор Турбо-страниц',
    'word-stat': 'Подбор слов',
    'word-stat-description':
        'Информация о том, сколько пользователей Яндекса в месяц ищут ту или иную фразу, и запросы, похожие по смыслу на вашу фразу.'
};
